import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  sidebarHeader: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    height: 64,
    gap: 15,
    padding: "16px",

    "& a": {
      color: theme.design.color.text.primary,
      fontSize: theme.design.typography.size.titleSmall,
      textDecoration: "none",
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },
  },

  sidebarLogo: {
    width: 40,
  },

  sidebarNavLink: {
    textDecoration: "none",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    color: theme.design.color.text.secondary,
    display: "flex",
    alignItems: "center",
    gap: theme.design.space.sm,

    "& span": {
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },

    "&.active": {
      color: theme.design.color.text.primary,
    },
  },

  sideBarConnectWalletBtn: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.design.color.surface.control,
    borderRadius: theme.design.radius.lg,
    color: theme.design.color.text.primary,

    "& span": {
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
    },
  },

  sidebarPaper: {
    backgroundColor: theme.design.color.surface.container,
    width: theme.design.layout.sidebarWidth,
    minWidth: theme.design.layout.sidebarWidth,
  },

  sideBar: {
    height: "100vh",
    width: theme.design.layout.sidebarWidth,
    minWidth: theme.design.layout.sidebarWidth,
    backgroundColor: theme.design.color.surface.container,
    display: "flex",
    flexDirection: "column",
    paddingTop: "120px",
    zIndex: theme.design.layer.sticky,
    boxSizing: "border-box",
    overflowY: "auto",
    borderRight: `1px solid ${theme.design.color.border.black}`,
    marginTop: 10
  },

  navLinkIcon: {
    width: 20,
    height: 20,
    flexShrink: 0,
    color: "currentColor",
  },

  navLinkText: {
    fontSize: 16,
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    userSelect: "none",
    whiteSpace: "nowrap",
  },

  navLinkGroup: {
    display: "flex",
    flexDirection: "column",
    marginTop: 0.5,
  },

  navLinkHeader: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    paddingRight: 12,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    textDecoration: "none",
  },

  navLinkHeaderContent: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    paddingLeft: 16,
    flexGrow: 1,
    justifyContent: "space-between",
  },

  navLinkHeaderContentPart: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },

  navLinks: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 12,
    paddingBottom: 24,
  },

  navLink: {
    padding: 4,
    paddingLeft: 24,
    transition: "background-color 0.3s",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,

    "& p": {
      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      fontSize: 16,
      textTransform: "none",
    },

    "&:hover": {
      backgroundColor: theme.design.color.surface.subtleHover,
    },
  },

  navLinkHeaderLine: {
    height: 1,
    width: "100%",
    backgroundColor: theme.design.color.overlay.white10,
    marginTop: 0,
    maxWidth: 80,
  },

  nowBadge: {
    backgroundColor: theme.design.color.overlay.white10,
    borderRadius: theme.design.radius.sm,
    color: theme.design.color.status.success,
    padding: "2px 8px",
    fontSize: 12,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
  },

  timeBadge: {
    backgroundColor: theme.design.color.overlay.white10,
    borderRadius: theme.design.radius.sm,
    color: theme.design.color.text.muted,
    padding: "2px 8px",
    fontSize: 12,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    whiteSpace: "nowrap",
  },

  killCountdownBadge: {
    backgroundColor: `color-mix(in srgb, ${theme.design.color.action.danger} 24%, ${theme.design.color.surface.container})`,
    border: `1px solid ${theme.design.color.action.danger}`,
    borderRadius: theme.design.radius.sm,
    color: theme.design.color.text.primary,
    padding: "2px 5px",
    fontSize: 11,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
  },
  navAction: {
    width: "100%",
    border: 0,
    background: "transparent",
    cursor: "pointer",
    textAlign: "left",
    "& span": {
      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      fontSize: 16,
    },
    "&:focus-visible": {
      outline: `2px solid ${theme.design.color.action.primaryHover}`,
      outlineOffset: -2,
    },
  },

  vaultCountdownBadge: {
    backgroundColor: `color-mix(in srgb, ${theme.design.color.status.warning} 24%, ${theme.design.color.surface.container})`,
    border: `1px solid ${theme.design.color.status.warning}`,
    borderRadius: theme.design.radius.sm,
    color: theme.design.color.status.warning,
    padding: "2px 4px",
    fontSize: 10,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
  },

  botBadge: {
    backgroundColor: theme.design.color.status.info,
    borderRadius: theme.design.radius.sm,
    color: theme.design.color.text.primary,
    padding: "2px 8px",
    fontSize: 12,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
  },

  badgeList: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginRight: "8px",
  },

  searchContainer: {
    padding: "4px 16px",
    borderBottom: `1px solid ${theme.design.color.overlay.white10}`,
    marginBottom: "16px",
  },

  searchInput: {
    width: "100%",
    padding: "4px",
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.design.color.overlay.white10,
      borderRadius: theme.design.radius.md,
      border: `1px solid ${theme.design.color.overlay.white10}`,
      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontWeight: 900,
      fontSize: 14,
      padding: "4px 12px",
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
      "& .MuiInputBase-input": {
        color: theme.design.color.text.primary,
        fontFamily: theme.design.typography.fontFamily,
        fontWeight: 900,
        fontSize: 14,
        padding: "4px 0px",
        "&::placeholder": {
          color: theme.design.color.overlay.white20,
          opacity: 1,
        },
      },
      "& .MuiInputAdornment-root": {
        color: theme.design.color.text.primary,
      },
      "& .MuiInputAdornment-positionStart": {
        marginRight: "8px",
      },
      "& .MuiInputAdornment-positionEnd": {
        marginLeft: "8px",
      },
    },
    "& .MuiInputBase-input": {
      padding: "6px",
      paddingLeft: "16px",
    }
  },

  searchIcon: {
    width: 16,
    height: 16,
    color: `${theme.design.color.text.primary} !important`,
    opacity: 0.7,
    "& svg": {
      color: `${theme.design.color.text.primary} !important`,
    },
  },

  clearIcon: {
    width: 16,
    height: 16,
    color: `${theme.design.color.text.primary} !important`,
    opacity: 0.7,
    "& svg": {
      color: `${theme.design.color.text.primary} !important`,
    },
  },

  profileDropdown: {
    position: "absolute",
    top: "100%",
    width: "210px",
    backgroundColor: theme.design.color.surface.subtleHover,
    border: `1px solid ${theme.design.color.overlay.white20}`,
    borderRadius: theme.design.radius.md,
    maxHeight: "200px",
    overflowY: "auto",
    zIndex: theme.design.layer.dropdown,
    marginTop: "4px",
    boxShadow: theme.design.shadow.dropdown,
    boxSizing: "border-box",
  },

  profileDropdownItem: {
    display: "block",
    padding: "12px 16px",
    color: theme.design.color.text.primary,
    boxSizing: "border-box",
    textDecoration: "none",
    borderBottom: `1px solid ${theme.design.color.overlay.white10}`,
    transition: "background-color 0.2s",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontSize: 14,

    "&:last-child": {
      borderBottom: "none",
    },

    "&:hover": {
      backgroundColor: theme.design.color.overlay.white10,
    },
  },

  formControl: {
    minWidth: 60,
    margin: 0,
    backgroundColor: theme.design.color.surface.interactive,
    borderRadius: theme.design.radius.md,

    "& .MuiInputBase-root": {
      height: "24.5px",
      fontSize: "13px",
      color: theme.design.color.text.primary,

      // minWidth: "150px",
      "&.Mui-disabled": {
        "& svg": {
          color: `${theme.design.color.text.muted}!important`,
        },
      },

      "& .MuiSelect-select": {
        textAlign: "center",
        fontFamily: theme.design.typography.fontFamily,

        "& img": {
          display: "none",
        },
      },

      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },

      "& .MuiSvgIcon-root, & .MuiSelect-icon, & svg": {
        color: theme.design.color.text.primary,
      },
    },
    "& .MuiMenu-paper": {
      padding: "0",
      display: "block",
      minWidth: "auto",
    },
  },
}));
